import Employeesheet from './employeesheet';
import { createSelector } from 'reselect';
import { initState } from './reducer';

const orderedpage = (state) => state.employeeReducer || initState;
const isUploadLoading = createSelector(orderedpage, (cnter) => cnter.isUploadLoading);
const uploadData = createSelector(orderedpage, (cnter) => cnter.uploadData);
const isUploadbuttonData = createSelector(orderedpage, (cnter) => cnter.isUploadbuttonData);
const isEmployeeLoading = createSelector(orderedpage, (cnter) => cnter.isEmployeeLoading);
const employeeData = createSelector(orderedpage, (cnter) => cnter.employeeData);
const isNationalLoading = createSelector(orderedpage, (cnter) => cnter.isNationalLoading);
const getnationalData = createSelector(orderedpage, (cnter) => cnter.getnationalData);

const isDelEmployeeLoading = createSelector(orderedpage, (cnter) => cnter.isDelEmployeeLoading);
const delemployeeData = createSelector(orderedpage, (cnter) => cnter.delemployeeData);

const isGetEmployeeLoading = createSelector(orderedpage, (cnter) => cnter.isGetEmployeeLoading);
const getemployeeData = createSelector(orderedpage, (cnter) => cnter.getemployeeData);
const isEmployeeDetails = createSelector(orderedpage, (cnter) => cnter.isEmployeeDetails);
const employeeDetails = createSelector(orderedpage, (cnter) => cnter.employeeDetails);
const isEmployeeAdd = createSelector(orderedpage, (cnter) => cnter.isEmployeeAdd);
const employeeAdd = createSelector(orderedpage, (cnter) => cnter.employeeAdd);
const postapiStatus = createSelector(orderedpage, (cnter) => cnter.postapiStatus);
const isBankNameLoading = createSelector(orderedpage, (cnter) => cnter.isBankNameLoading);
const getbanknameData = createSelector(orderedpage, (cnter) => cnter.getbanknameData);
const isOrderCardLoading = createSelector(orderedpage, (cnter) => cnter.isOrderCardLoading);
const ordercardData = createSelector(orderedpage, (cnter) => cnter.ordercardData);

const isSalaryTemplateLoading = createSelector(orderedpage, (cnter) => cnter.isSalaryTemplateLoading);
const salarytemplateData = createSelector(orderedpage, (cnter) => cnter.salarytemplateData);
export default {
	isEmployeeLoading,
	employeeData,
	isGetEmployeeLoading,
	getemployeeData,
	isEmployeeDetails,
	employeeDetails,
	isEmployeeAdd,
	employeeAdd,
	isNationalLoading,
	getnationalData,
	isDelEmployeeLoading,
	delemployeeData,
	getbanknameData,
	isBankNameLoading,
	postapiStatus,
	isOrderCardLoading,
	ordercardData,
	isSalaryTemplateLoading,
	salarytemplateData,
	isUploadbuttonData,
	uploadData,
	isUploadLoading,
};
